// App/AdminPortal/features/Settings/columns.js
import React from "react";
import { Button, Tag, Image, Typography } from "antd";
import editIcon from "../../../../assets/icons/edit.svg";
import { colors } from "../../utils/colors";
import { RoutesLookup } from '../../../Routes/RoutesLookup';
import { DATAGRID_DEFAULT_PAGE_SIZE } from '../../../Constants/ApplicationConstants';
import { EyeOutlined, StarFilled } from "@ant-design/icons";

export const getColumns = ({ navigate, page, pageSize, statusType }) => [
  // {
  //   title: "ID",
  //   key: "1",
  //   dataIndex: "GLIM_KeyID",
  //   width: "10%",
  // },
  {
    title: "IMAGE",
    key: "2",
    dataIndex: "GLIM_Image_Path",
    width: "15%",
    align: "center",
    render: (src, record) => (
      <div style={{ position: "relative" }}>
        {src ? (
          <Image 
            src={src} 
            alt="Global Image" 
            preview={true}
            style={{
              width: 100,
              height: 100,
              objectFit: "contain",
              borderRadius: 8
            }}
          />
        ) : null}
        {record.GLIM_Is_Default && (
          <div style={{ 
            position: "absolute", 
            top: -8, 
            left: -8, 
            backgroundColor: colors.blue500,
            borderRadius: "50%",
            padding: "4px",
          }}>
            <StarFilled style={{ color: "white", fontSize: "16px" }} />
          </div>
        )}
      </div>
    )
  },
  {
    title: "DESCRIPTION",
    key: "3",
    dataIndex: "GLIM_Description",
    width: "15%",
  },
  {
    title: "IMAGE USAGE",
    key: "4",
    dataIndex: "GLIM_Image_Usage_GLIU_KeyID",
    width: "15%",
  },
  {
    title: "START DATE",
    key: "5",
    dataIndex: "GLIM_Date_From",
    width: "10%",
    render: (date) => (
      <Typography.Text>
        {date ? new Date(date).toLocaleDateString() : "N/A"}
      </Typography.Text>
    ),
  },
  {
    title: "END DATE",
    key: "6",
    dataIndex: "GLIM_Date_To",
    width: "10%",
    render: (date) => (
      <Typography.Text>
        {date ? new Date(date).toLocaleDateString() : "N/A"}
      </Typography.Text>
    ),
  },
  {
    title: "STATUS",
    key: "7",
    width: "10%",
    align: "center",
    render: (_, object) => {
      // Determine if image is active based on current date and date range
      const now = new Date();
      const startDate = new Date(object.GLIM_Date_From);
      const endDate = object.GLIM_Date_To ? new Date(object.GLIM_Date_To) : null;
      const isActive = startDate <= now && (!endDate || endDate >= now);
      
      return (
        <Tag
          style={{
            border: "none",
            width: 66,
            textAlign: "center",
            borderRadius: 10,
            color: colors.grey900,
            backgroundColor: isActive ? colors.green500 : colors.red300,
          }}
        >
          {isActive ? "Active" : "Inactive"}
        </Tag>
      );
    }
  },
  {
    title: "DEFAULT",
    key: "8",
    width: "10%",
    align: "center",
    render: (_, object) => (
      object.GLIM_Is_Default ? (
        <Tag
          style={{
            border: "none",
            width: 66,
            textAlign: "center",
            borderRadius: 10,
            color: colors.grey900,
            backgroundColor: colors.green500,
          }}
        >
          Default
        </Tag>
      ) : null
    )
  },
  {
    title: "EDIT / VIEW",
    key: "9",
    width: "15%",
    align: "center",
    render: (_, object) => (
      <div className="flex justify-center space-x-2">
        <Button
          type="link"
          onClick={() => {
            navigate(
              `${RoutesLookup.SETTINGS}/${object.GLIM_KeyID}?page=${page ?? 1
              }&pageSize=${pageSize ?? DATAGRID_DEFAULT_PAGE_SIZE}&statusType=${statusType ?? undefined
              }`
            );
          }}
        >
          <Image src={editIcon} alt="edit" preview={false} style={{ transform: 'scale(1.5)' }}/>
        </Button>
        <Button
          type="link"
          onClick={() => {
            navigate(
              `${RoutesLookup.SETTINGS}/view/${object.GLIM_KeyID}?page=${page ?? 1
              }&pageSize=${pageSize ?? DATAGRID_DEFAULT_PAGE_SIZE}&statusType=${statusType ?? undefined
              }`
            );
          }}
        >
          <EyeOutlined style={{ fontSize: '180%' }}/>
        </Button>
      </div>
    ),
  },
];